import {   FaUsersCog } from "react-icons/fa";
export const  Dashboard_sidebar_links=[{
    key:"1",
    label:"Register Data",
    path:"/registered",
    icon:<FaUsersCog/>

},
{
    key:"2",
    label:"Prediction Data",
    path:"/predictiondata",
    icon:<FaUsersCog/>
}
]